<template>
  <div class="c202b-offline">
    <div class="pagemargins">
      <table
        cellspacing="0"
        cellpadding="0"
        border="0"
        style="border-width: 0px; width: 718px; border-collapse: collapse; white-space: normal"
      >
        <tr style="height: 41px">
          <td
            class="sDetailTextCenter"
            colspan="3"
            rowspan="2"
            style="height: 63px; width: 143px; max-height: 63px; max-width: 143px"
          >
            Không ghi vào <br />khu vực này
          </td>
          <td class="sc711c7f2" style="width: 49px; height: 40px"></td>
          <td style="height: 40px; width: 37px; border: 0px"></td>
          <td style="height: 40px; width: 1px; border: 0px"></td>
          <td style="height: 40px; width: 7px; border: 0px"></td>
          <td style="height: 40px; width: 42px; border: 0px"></td>
          <td style="height: 40px; width: 3px; border: 0px"></td>
          <td style="height: 40px; width: 19px; border: 0px"></td>
          <td style="height: 40px; width: 8px; border: 0px"></td>
          <td style="height: 40px; width: 7px; border: 0px"></td>
          <td style="height: 40px; width: 16px; border: 0px"></td>
          <td style="height: 40px; width: 15px; border: 0px"></td>
          <td style="height: 40px; width: 26px; border: 0px"></td>
          <td style="height: 40px; width: 4px; border: 0px"></td>
          <td style="height: 40px; width: 15px; border: 0px"></td>
          <td style="height: 40px; width: 8px; border: 0px"></td>
          <td style="height: 40px; width: 7px; border: 0px"></td>
          <td style="height: 40px; width: 15px; border: 0px"></td>
          <td style="height: 40px; width: 61px; border: 0px"></td>
          <td style="height: 40px; width: 7px; border: 0px"></td>
          <td style="height: 40px; width: 1px; border: 0px"></td>
          <td class="sFormNo" colspan="11" style="height: 41px; width: 227px; max-height: 41px; max-width: 227px">
            Mẫu số 16a2<br />Ký hiệu: C2-02b/NS
          </td>
        </tr>
        <tr style="height: 23px">
          <td class="sc711c7f2" style="width: 49px; height: 23px"></td>
          <td style="height: 23px; width: 37px; border: 0px"></td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td style="height: 23px; width: 42px; border: 0px"></td>
          <td style="height: 23px; width: 3px; border: 0px"></td>
          <td style="height: 23px; width: 19px; border: 0px"></td>
          <td style="height: 23px; width: 8px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td style="height: 23px; width: 16px; border: 0px"></td>
          <td style="height: 23px; width: 15px; border: 0px"></td>
          <td style="height: 23px; width: 26px; border: 0px"></td>
          <td style="height: 23px; width: 4px; border: 0px"></td>
          <td style="height: 23px; width: 15px; border: 0px"></td>
          <td style="height: 23px; width: 8px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td style="height: 23px; width: 15px; border: 0px"></td>
          <td style="height: 23px; width: 61px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td class="sDetailText" colspan="8" style="height: 23px; width: 121px; max-height: 23px; max-width: 121px">
            Số: {{ model.ref_no }}
          </td>
          <td class="sDetailText1" colspan="3" style="height: 23px; width: 106px; max-height: 23px; max-width: 106px">
            Năm NS: {{ model.posted_year }}
          </td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 8px">
          <td class="sd6f96e9b" style="width: 8px; height: 7px"></td>
          <td class="sd6f96e9b" style="width: 105px; height: 7px"></td>
          <td class="sd6f96e9b" style="width: 31px; height: 7px"></td>
          <td style="height: 7px; width: 49px; border: 0px"></td>
          <td style="height: 7px; width: 37px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 42px; border: 0px"></td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td style="height: 7px; width: 19px; border: 0px"></td>
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 16px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 26px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 61px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
          <td style="height: 7px; width: 11px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 34px; border: 0px"></td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 49px; border: 0px"></td>
          <td style="height: 7px; width: 68px; border: 0px"></td>
          <td style="height: 7px; width: 31px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 29px">
          <td class="sReportTitle" colspan="33" style="height: 29px; width: 718px; max-height: 29px; max-width: 718px">
            GIẤY RÚT DỰ TOÁN NGÂN SÁCH NHÀ NƯỚC
          </td>
          <td style="height: 29px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 105px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 37px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 42px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 16px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 61px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 11px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 68px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 105px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 37px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 42px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td class="s47c6a550" style="width: 19px; height: 4px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 16px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td class="s47c6a550" style="width: 4px; height: 4px"></td>
          <td class="s47c6a550" style="width: 15px; height: 4px"></td>
          <td class="s9865db0d" style="width: 8px; height: 4px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 4px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 61px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 11px; border: 0px"></td>
          <td class="s47c6a550" style="width: 15px; height: 4px"></td>
          <td class="s47c6a550" style="width: 4px; height: 4px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 68px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td style="height: 18px; width: 105px; border: 0px"></td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 49px; border: 0px"></td>
          <td style="height: 18px; width: 37px; border: 0px"></td>
          <td class="sDetailText2" colspan="4" style="height: 19px; width: 53px; max-height: 19px; max-width: 53px">
            Thực chi
          </td>
          <td class="sDetailTextCenter" style="height: 18px; width: 18px">
            {{ model.cash_withdraw_type_id == 6 ? 'x' : '' }}
          </td>
          <td class="sc711c7f2" style="width: 8px; height: 18px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td class="sDetailText2" colspan="3" style="height: 19px; width: 57px; max-height: 19px; max-width: 57px">
            Tạm ứng
          </td>
          <td class="sDetailTextCenter" colspan="2" style="height: 18px; width: 18px">
            {{ model.cash_withdraw_type_id == 2 || model.cash_withdraw_type_id == 3 ? 'x' : '' }}
          </td>
          <td class="s858ff519" style="width: 8px; height: 18px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 18px"></td>
          <td class="sDetailText3" colspan="5" style="height: 19px; width: 95px; max-height: 19px; max-width: 95px">
            Chuyển khoản
          </td>
          <td class="sCT_Table_DetailText_MLNS" colspan="2" style="width: 18px; height: 18px">
            {{ model.PaymentMethod == 0 ? 'x' : '' }}
          </td>
          <td class="sc711c7f2" style="width: 34px; height: 18px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 4px; border: 0px"></td>
          <td style="height: 18px; width: 49px; border: 0px"></td>
          <td style="height: 18px; width: 68px; border: 0px"></td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 105px; border: 0px"></td>
          <td style="height: 3px; width: 31px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 37px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 42px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td class="sd6f96e9b" style="width: 19px; height: 3px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 16px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 26px; border: 0px"></td>
          <td class="sd6f96e9b" style="width: 4px; height: 3px"></td>
          <td class="sd6f96e9b" style="width: 15px; height: 3px"></td>
          <td class="s9865db0d" style="width: 8px; height: 3px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 3px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 61px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 11px; border: 0px"></td>
          <td class="s1c15de7e" style="width: 15px; height: 3px"></td>
          <td class="s1c15de7e" style="width: 4px; height: 3px"></td>
          <td style="height: 3px; width: 34px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 68px; border: 0px"></td>
          <td style="height: 3px; width: 31px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td style="height: 18px; width: 105px; border: 0px"></td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 49px; border: 0px"></td>
          <td style="height: 18px; width: 37px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 42px; border: 0px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 19px; border: 0px"></td>
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 16px; border: 0px"></td>
          <td style="height: 18px; width: 15px; border: 0px"></td>
          <td style="height: 18px; width: 26px; border: 0px"></td>
          <td style="height: 18px; width: 4px; border: 0px"></td>
          <td style="height: 18px; width: 15px; border: 0px"></td>
          <td class="s9865db0d" style="width: 8px; height: 18px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 18px"></td>
          <td class="sDetailText3" colspan="5" style="height: 19px; width: 95px; max-height: 19px; max-width: 95px">
            Tiền mặt tại KB
          </td>
          <td class="sCT_Table_DetailText_MLNS" colspan="2" style="width: 18px; height: 18px">
            {{ model.PaymentMethod == 2 ? 'x' : '' }}
          </td>
          <td class="sc711c7f2" style="width: 34px; height: 18px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 4px; border: 0px"></td>
          <td style="height: 18px; width: 49px; border: 0px"></td>
          <td style="height: 18px; width: 68px; border: 0px"></td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td style="height: 2px; width: 8px; border: 0px"></td>
          <td style="height: 2px; width: 105px; border: 0px"></td>
          <td style="height: 2px; width: 31px; border: 0px"></td>
          <td style="height: 2px; width: 49px; border: 0px"></td>
          <td style="height: 2px; width: 37px; border: 0px"></td>
          <td style="height: 2px; width: 1px; border: 0px"></td>
          <td style="height: 2px; width: 7px; border: 0px"></td>
          <td style="height: 2px; width: 42px; border: 0px"></td>
          <td style="height: 2px; width: 3px; border: 0px"></td>
          <td style="height: 2px; width: 19px; border: 0px"></td>
          <td style="height: 2px; width: 8px; border: 0px"></td>
          <td style="height: 2px; width: 7px; border: 0px"></td>
          <td style="height: 2px; width: 16px; border: 0px"></td>
          <td style="height: 2px; width: 15px; border: 0px"></td>
          <td style="height: 2px; width: 26px; border: 0px"></td>
          <td style="height: 2px; width: 4px; border: 0px"></td>
          <td style="height: 2px; width: 15px; border: 0px"></td>
          <td class="s9865db0d" style="width: 8px; height: 2px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 2px"></td>
          <td style="height: 2px; width: 15px; border: 0px"></td>
          <td style="height: 2px; width: 61px; border: 0px"></td>
          <td style="height: 2px; width: 7px; border: 0px"></td>
          <td style="height: 2px; width: 1px; border: 0px"></td>
          <td style="height: 2px; width: 11px; border: 0px"></td>
          <td class="s1c15de7e" style="width: 15px; height: 2px"></td>
          <td class="s1c15de7e" style="width: 4px; height: 2px"></td>
          <td style="height: 2px; width: 34px; border: 0px"></td>
          <td style="height: 2px; width: 3px; border: 0px"></td>
          <td style="height: 2px; width: 4px; border: 0px"></td>
          <td style="height: 2px; width: 49px; border: 0px"></td>
          <td style="height: 2px; width: 68px; border: 0px"></td>
          <td style="height: 2px; width: 31px; border: 0px"></td>
          <td style="height: 2px; width: 7px; border: 0px"></td>
          <td style="height: 2px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td style="height: 18px; width: 105px; border: 0px"></td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 49px; border: 0px"></td>
          <td style="height: 18px; width: 37px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 42px; border: 0px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 19px; border: 0px"></td>
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 16px; border: 0px"></td>
          <td style="height: 18px; width: 15px; border: 0px"></td>
          <td style="height: 18px; width: 26px; border: 0px"></td>
          <td style="height: 18px; width: 4px; border: 0px"></td>
          <td style="height: 18px; width: 15px; border: 0px"></td>
          <td class="s9865db0d" style="width: 8px; height: 18px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 18px"></td>
          <td class="sDetailText3" colspan="5" style="height: 19px; width: 95px; max-height: 19px; max-width: 95px">
            Tiền mặt tại NH
          </td>
          <td class="sCT_Table_DetailText_MLNS" colspan="2" style="width: 18px; height: 18px">
            {{ model.PaymentMethod == 3 ? 'x' : '' }}
          </td>
          <td class="sc711c7f2" style="width: 34px; height: 18px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 4px; border: 0px"></td>
          <td style="height: 18px; width: 49px; border: 0px"></td>
          <td style="height: 18px; width: 68px; border: 0px"></td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 8px">
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 105px; border: 0px"></td>
          <td style="height: 7px; width: 31px; border: 0px"></td>
          <td style="height: 7px; width: 49px; border: 0px"></td>
          <td style="height: 7px; width: 37px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 42px; border: 0px"></td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td style="height: 7px; width: 19px; border: 0px"></td>
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 16px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 26px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 61px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
          <td style="height: 7px; width: 11px; border: 0px"></td>
          <td class="sd6f96e9b" style="width: 15px; height: 7px"></td>
          <td class="sd6f96e9b" style="width: 4px; height: 7px"></td>
          <td style="height: 7px; width: 34px; border: 0px"></td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 49px; border: 0px"></td>
          <td style="height: 7px; width: 68px; border: 0px"></td>
          <td style="height: 7px; width: 31px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td
            class="s57af6888 no-warp"
            colspan="2"
            style="height: 15px; width: 113px; max-height: 15px; max-width: 127px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Đơn vị rút dự toán:&nbsp;
          </td>
          <td
            class="s57af6888"
            colspan="31"
            style="height: 15px; width: 605px; max-height: 15px; max-width: 605px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{ model.CompanyName }}
          </td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 105px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 37px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 42px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 16px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 61px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 11px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 68px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="s57af6888 title-org" colspan="33" :style="{fontSize: model.font_size + fontSizeDV}">
            <span>Tài khoản: {{ model.bank_info_code }}</span> &nbsp;&nbsp;&nbsp; Tại KBNN: {{ model.bank_info_name }}
          </td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 105px; border: 0px"></td>
          <td style="height: 3px; width: 31px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 37px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 42px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 16px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 26px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 61px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 11px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 34px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 68px; border: 0px"></td>
          <td style="height: 3px; width: 31px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
        </tr>
        <tr class="model.project_code ? 'h-19px' : 'h-31px'">
          <td
            class="s65b279dc"
            colspan="33"
            style="white-space: pre-wrap; max-width: 718px; width: 718px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <div>
              <span>Tên CTMT, DA:</span>
              <span>{{ model.project_name }}</span>
              <span v-if="model.project_code">&nbsp;&nbsp; Mã CTMT, DA: {{ model.project_code }}</span>
            </div>
            <div v-if="!model.project_code || model.project_code == ''">
              ...................................................................................... Mã CTMT, DA:
              .........................................................................................................
            </div>
          </td>
          <td style="width: 1px; border: 0px" :class="model.project_code ? 'h-19px' : 'h-31px'"></td>
        </tr>
        <tr style="height: 19px">
          <td
            class="s57af6888"
            colspan="33"
            style="white-space: nowrap; height: 19px; max-width: 718px; width: 718px; max-height: 19px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Số CKC, HĐK: {{ model.contract_template }} &nbsp;&nbsp; Số CKC, HĐTH: {{ model.contract_perform }}
          </td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 8px">
          <td class="s5f74eea3" style="width: 8px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 105px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 31px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 49px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 37px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 1px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 7px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 42px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 3px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 19px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 8px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 7px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 16px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 15px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 26px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 4px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 15px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 8px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 7px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 15px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 61px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 7px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 1px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 11px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 15px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 4px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 34px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 3px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 4px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 49px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 68px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 31px; height: 8px"></td>
          <td class="s5f74eea3" style="width: 7px; height: 8px"></td>
          <td style="height: 8px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td
            class="sDetailHeader"
            colspan="6"
            rowspan="2"
            style="height: 52px; width: 230px; max-height: 52px; max-width: 230px"
          >
            Nội dung thanh toán
          </td>
          <td
            class="sDetailHeader1"
            colspan="2"
            rowspan="2"
            style="height: 52px; width: 48px; max-height: 52px; max-width: 48px"
          >
            Mã NDKT
          </td>
          <td
            class="sDetailHeader1"
            colspan="5"
            rowspan="2"
            style="height: 52px; width: 52px; max-height: 52px; max-width: 52px"
          >
            Mã chương
          </td>
          <td
            class="sDetailHeader1"
            colspan="3"
            rowspan="2"
            style="height: 52px; width: 44px; max-height: 52px; max-width: 44px"
          >
            Mã ngành KT
          </td>
          <td
            class="sDetailHeader1"
            colspan="4"
            rowspan="2"
            style="height: 52px; width: 44px; max-height: 52px; max-width: 44px"
          >
            Mã nguồn NSNN
          </td>
          <td
            class="sDetailHeader1"
            colspan="5"
            rowspan="2"
            style="height: 52px; width: 94px; max-height: 52px; max-width: 94px"
          >
            Tổng số tiền
          </td>
          <td class="sDetailHeader1" colspan="8" style="height: 18px; width: 199px; max-height: 18px; max-width: 199px">
            Chia ra
          </td>
          <td class="s0e3ffc9a" style="width: 1px; height: 18px"></td>
        </tr>
        <tr style="height: 34px">
          <td class="sDetailHeader1" colspan="5" style="height: 33px; width: 93px; max-height: 33px; max-width: 93px">
            Nộp thuế
          </td>
          <td class="sDetailHeader1" colspan="3" style="height: 33px; width: 105px; max-height: 33px; max-width: 105px">
            Thanh toán cho ĐV hưởng
          </td>
          <td class="s0e3ffc9a" style="width: 1px; height: 33px"></td>
        </tr>
        <tr style="height: 23px">
          <td class="sBC_Table_SubHeader" colspan="6" style="height: 22px; width: 230px">(1)</td>
          <td class="sBC_Table_SubHeader1" colspan="2" style="height: 22px; width: 48px">(2)</td>
          <td class="sBC_Table_SubHeader1" colspan="5" style="height: 22px; width: 52px">(3)</td>
          <td class="sBC_Table_SubHeader1" colspan="3" style="height: 22px; width: 44px">(4)</td>
          <td class="sBC_Table_SubHeader1" colspan="4" style="height: 22px; width: 44px">(5)</td>
          <td
            class="sBC_Table_SubHeader2"
            colspan="5"
            style="height: 22px; max-width: 94px; width: 94px; max-height: 22px; padding: 0px 0px 0px 0px"
          >
            (6) = (7) + (8)
          </td>
          <td class="sBC_Table_SubHeader1" colspan="5" style="height: 22px; width: 93px; padding: 0px 0px 0px 0px">
            (7)
          </td>
          <td class="sBC_Table_SubHeader1" colspan="3" style="height: 22px; width: 105px; padding: 0px 0px 0px 0px">
            (8)
          </td>
          <td class="sc711c7f2" style="width: 1px; height: 22px"></td>
        </tr>
        <template v-for="(item, index) in model.DetailReport" :key="index">
          <tr style="height: 22px" class="table-row">
            <td
              class="sefb06f20"
              colspan="6"
              style="height: 21px; width: 230px; max-height: 21px; max-width: 230px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{ item.description }}
            </td>
            <td
              class="s61cae64c"
              colspan="2"
              style="height: 21px; width: 48px; max-height: 21px; max-width: 48px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{ item.budget_sub_item_code }}
            </td>
            <td
              class="s61cae64c"
              colspan="5"
              style="height: 21px; width: 52px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{ item.budget_chapter_code }}
            </td>
            <td
              class="s61cae64c"
              colspan="3"
              style="height: 21px; width: 44px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{ item.budget_sub_kind_item_code }}
            </td>
            <td
              class="s61cae64c"
              colspan="4"
              style="height: 21px; width: 44px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{ item.budget_source_property_code }}
            </td>
            <td
              class="sfcb10c25"
              colspan="5"
              style="height: 21px; max-width: 94px; width: 94px; max-height: 21px; padding: 0px 0px 0px 0px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{
                $ms.format.formatData(item.amount, {
                  formatType: 2,
                })
              }}
            </td>
            <td
              class="sfcb10c25"
              colspan="5"
              style="height: 21px; width: 93px; padding: 0px 0px 0px 0px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{
                $ms.format.formatData(item.tax_amount, {
                  formatType: 2,
                })
              }}
            </td>
            <td
              class="sfcb10c25"
              colspan="3"
              style="height: 21px; max-width: 105px; width: 105px; max-height: 21px; padding: 0px 0px 0px 0px"
              :style="{fontSize: model.font_size + fontSizeDV}"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            >
              {{
                $ms.format.formatData(item.payment_amount, {
                  formatType: 2,
                })
              }}
            </td>
            <td
              class="sc711c7f2"
              style="width: 1px; height: 21px"
              :class="{'border-bottom-none': index == model.DetailReport?.length - 1}"
            ></td>
          </tr>
        </template>
        <tr style="height: 22px" v-if="model.use_add_info && model.add_info">
          <td
            class="sd12598ef"
            colspan="6"
            style="height: 21px; width: 230px; max-height: 21px; max-width: 230px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{ model.add_info }}
          </td>
          <td class="sb32a2c63" colspan="2" style="height: 21px; width: 48px"></td>
          <td class="sb32a2c63" colspan="5" style="height: 21px; width: 52px"></td>
          <td class="sb32a2c63" colspan="3" style="height: 21px; width: 44px"></td>
          <td class="sb32a2c63" colspan="4" style="height: 21px; width: 44px"></td>
          <td class="s12e6f447" colspan="5" style="height: 21px; width: 94px; padding: 0px 0px 0px 0px"></td>
          <td class="s12e6f447" colspan="5" style="height: 21px; width: 93px; padding: 0px 0px 0px 0px"></td>
          <td class="s12e6f447" colspan="3" style="height: 21px; width: 105px; padding: 0px 0px 0px 0px"></td>
          <td class="s478c64ad" style="width: 1px; height: 21px"></td>
        </tr>
        <tr style="height: 60px" v-if="model.use_sec">
          <td
            class="s710795cf"
            colspan="6"
            style="height: 59px; width: 230px; max-height: 59px; max-width: 230px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{ model.add_sec_info }}:
            {{ model.CompanyName }}
            Số CMND: {{ model.paramIdentification_number ? model.paramIdentification_number : '.................' }} Cấp
            ngày: {{ model.issueDate ? model.issueDate : '............' }} Nơi cấp:
            {{ model.issueBy ? model.issueBy : '..............' }}
          </td>
          <td class="scc89512f" colspan="2" style="height: 59px; width: 48px"></td>
          <td class="scc89512f" colspan="5" style="height: 59px; width: 52px"></td>
          <td class="scc89512f" colspan="3" style="height: 59px; width: 44px"></td>
          <td class="scc89512f" colspan="4" style="height: 59px; width: 44px"></td>
          <td class="se65b108d" colspan="5" style="height: 59px; width: 94px; padding: 0px 0px 0px 0px"></td>
          <td class="se65b108d" colspan="5" style="height: 59px; width: 93px; padding: 0px 0px 0px 0px"></td>
          <td class="se65b108d" colspan="3" style="height: 59px; width: 105px; padding: 0px 0px 0px 0px"></td>
          <td class="s478c64ad" style="width: 1px; height: 59px"></td>
        </tr>
        <tr style="height: 23px" :style="{fontSize: model.font_size + fontSizeDV}" class="table-row">
          <td class="s2e415322" colspan="20" style="height: 22px; width: 422px; max-height: 22px; max-width: 422px">
            Tổng cộng
          </td>
          <td
            class="s096ed1b5"
            colspan="5"
            style="height: 22px; max-width: 94px; width: 94px; max-height: 22px; padding: 0px 0px 0px 0px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{
              $ms.format.formatData(model.total_amonut, {
                formatType: 2,
              })
            }}
          </td>
          <td
            class="s096ed1b5"
            colspan="5"
            style="height: 22px; max-width: 93px; width: 93px; max-height: 22px; padding: 0px 0px 0px 0px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{
              $ms.format.formatData(model.total_amonut_tax, {
                formatType: 2,
              })
            }}
          </td>
          <td
            class="s096ed1b5"
            colspan="3"
            style="height: 22px; max-width: 105px; width: 105px; max-height: 22px; padding: 0px 0px 0px 0px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            {{
              $ms.format.formatData(model.total_payment_amount, {
                formatType: 2,
              })
            }}
          </td>
          <td class="s0e3ffc9a" style="width: 1px; height: 22px"></td>
        </tr>
        <tr style="height: 10px" class="footer-report">
          <td class="s59a6c521" style="width: 8px; height: 10px"></td>
          <td class="s59a6c521" style="width: 105px; height: 10px"></td>
          <td class="s59a6c521" style="width: 31px; height: 10px"></td>
          <td class="s59a6c521" style="width: 49px; height: 10px"></td>
          <td class="s59a6c521" style="width: 37px; height: 10px"></td>
          <td class="s59a6c521" style="width: 1px; height: 10px"></td>
          <td class="s59a6c521" style="width: 7px; height: 10px"></td>
          <td class="s59a6c521" style="width: 42px; height: 10px"></td>
          <td class="s59a6c521" style="width: 3px; height: 10px"></td>
          <td class="s59a6c521" style="width: 19px; height: 10px"></td>
          <td class="s59a6c521" style="width: 8px; height: 10px"></td>
          <td class="s59a6c521" style="width: 7px; height: 10px"></td>
          <td class="s59a6c521" style="width: 16px; height: 10px"></td>
          <td class="s59a6c521" style="width: 15px; height: 10px"></td>
          <td class="s59a6c521" style="width: 26px; height: 10px"></td>
          <td class="s59a6c521" style="width: 4px; height: 10px"></td>
          <td class="s59a6c521" style="width: 15px; height: 10px"></td>
          <td class="s59a6c521" style="width: 8px; height: 10px"></td>
          <td class="s59a6c521" style="width: 7px; height: 10px"></td>
          <td class="s59a6c521" style="width: 15px; height: 10px"></td>
          <td class="s59a6c521" style="width: 61px; height: 10px"></td>
          <td class="s59a6c521" style="width: 7px; height: 10px"></td>
          <td class="s59a6c521" style="width: 1px; height: 10px"></td>
          <td class="s59a6c521" style="width: 11px; height: 10px"></td>
          <td class="s59a6c521" style="width: 15px; height: 10px"></td>
          <td class="s59a6c521" style="width: 4px; height: 10px"></td>
          <td class="s59a6c521" style="width: 34px; height: 10px"></td>
          <td class="s59a6c521" style="width: 3px; height: 10px"></td>
          <td class="s59a6c521" style="width: 4px; height: 10px"></td>
          <td class="sa5d47ccf" style="width: 49px; height: 10px"></td>
          <td class="sa5d47ccf" style="width: 68px; height: 10px"></td>
          <td class="sa5d47ccf" style="width: 31px; height: 10px"></td>
          <td class="s59a6c521" style="width: 7px; height: 10px"></td>
          <td style="height: 10px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 105px; border: 0px"></td>
          <td style="height: 3px; width: 31px; border: 0px"></td>
          <td style="height: 3px; width: 49px; border: 0px"></td>
          <td style="height: 3px; width: 37px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 42px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td style="height: 3px; width: 19px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 16px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 26px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 8px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 61px; border: 0px"></td>
          <td style="height: 3px; width: 7px; border: 0px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
          <td style="height: 3px; width: 11px; border: 0px"></td>
          <td style="height: 3px; width: 15px; border: 0px"></td>
          <td style="height: 3px; width: 4px; border: 0px"></td>
          <td style="height: 3px; width: 34px; border: 0px"></td>
          <td style="height: 3px; width: 3px; border: 0px"></td>
          <td class="s2fc2a26e" style="width: 4px; height: 3px"></td>
          <td
            class="sDetailHeader2"
            colspan="3"
            rowspan="3"
            style="height: 26px; width: 147px; max-height: 26px; max-width: 147px"
          >
            PHẦN KBNN GHI
          </td>
          <td class="sc711c7f2" style="width: 7px; height: 3px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px" :style="{fontSize: model.font_size + fontSizeDV}">
          <td
            class="s57af6888 line-height-114"
            colspan="28"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Tổng số tiền ghi bằng chữ: {{ model.total_amonut_text }}</span>
          </td>
          <td class="s2fc2a26e" style="width: 4px; height: 19px"></td>
          <td class="sc711c7f2" style="width: 7px; height: 19px"></td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td
            class="s57af6888"
            colspan="28"
            rowspan="2"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Trong đó:
          </td>
          <td class="s2fc2a26e" style="width: 4px; height: 4px"></td>
          <td class="sc711c7f2" style="width: 7px; height: 4px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td class="s9865db0d" style="width: 4px; height: 14px"></td>
          <td
            class="sDetailGroupItemTextBoldLeft"
            colspan="3"
            rowspan="2"
            style="height: 18px; width: 147px; max-height: 18px; max-width: 147px"
          >
            1. Nộp thuế:
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 14px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td
            class="sHeaderValueTextBold"
            colspan="28"
            rowspan="3"
            style="height: 22px; width: 559px; max-height: 22px; max-width: 559px"
          >
            NỘP THUẾ:
          </td>
          <td class="s9865db0d" style="width: 4px; height: 4px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 4px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td class="s9865db0d" style="width: 4px; height: 15px"></td>
          <td class="sDetailText4" colspan="3" style="height: 15px; width: 148px; max-height: 15px; max-width: 148px">
            Nợ TK: {{ model.debit_account_tax_1 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 15px"></td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td class="s9865db0d" style="width: 4px; height: 3px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Có TK: {{ model.credit_account_tax_1 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 3px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 12px">
          <td
            class="s57af6888"
            colspan="28"
            rowspan="2"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Tên đơn vị (Người nộp thuế): {{ model.company_name }}
          </td>
          <td class="s9865db0d" style="width: 4px; height: 12px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 12px"></td>
          <td style="height: 12px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 7px">
          <td class="s9865db0d" style="width: 4px; height: 7px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Nợ TK: {{ model.debit_account_tax_2 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 7px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 8px">
          <td
            class="s57af6888 ver-top"
            colspan="4"
            rowspan="2"
            style="height: 19px; width: 193px; max-height: 19px; max-width: 193px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Mã số thuế: {{ model.company_tax_code }}
          </td>
          <td
            class="sDetailText ver-top"
            colspan="11"
            rowspan="2"
            style="height: 19px; width: 181px; max-height: 19px; max-width: 181px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Mã NDKT: {{ model.NDKT_code }}
          </td>
          <td
            class="sDetailText ver-top"
            colspan="13"
            rowspan="2"
            style="height: 19px; width: 185px; max-height: 19px; max-width: 185px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Mã chương: {{ model.budget_chapter_code }}
          </td>
          <td class="s9865db0d" style="width: 4px; height: 8px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 8px"></td>
          <td style="height: 8px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 11px">
          <td class="s9865db0d" style="width: 4px; height: 11px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 14px; width: 148px; max-height: 14px; max-width: 148px"
          >
            Có TK: {{ model.credit_account_tax_2 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 11px"></td>
          <td style="height: 11px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td
            class="s57af6888"
            colspan="28"
            rowspan="4"
            style="height: 31px; width: 559px; max-height: 31px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Cơ quan quản lý thu: {{ model.receipt_agency_name }}. Kỳ thuế:
            {{ model.tax_period }}
          </td>
          <td class="s9865db0d" style="width: 4px; height: 3px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 3px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td class="s9865db0d" style="width: 4px; height: 1px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Nợ TK: {{ model.debit_account_tax_3 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 1px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 14px">
          <td class="s9865db0d" style="width: 4px; height: 14px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 14px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 13px">
          <td class="s9865db0d" style="width: 4px; height: 13px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Có TK: {{ model.credit_account_tax_3 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 13px"></td>
          <td style="height: 13px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 2px">
          <td
            class="s57af6888"
            colspan="28"
            rowspan="4"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            KBNN hạch toán khoản thu:
            {{ model.state_bank_name }}
          </td>
          <td class="s9865db0d" style="width: 4px; height: 2px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 2px"></td>
          <td style="height: 2px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 4px; border: 0px" class="border-right"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 68px; border: 0px"></td>
          <td style="height: 1px; width: 31px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px" class="border-left"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td class="s9865db0d" style="width: 4px; height: 15px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Mã CQ thu: {{ model.collection_agency_tax_code }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 15px"></td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td class="s9865db0d" style="width: 4px; height: 1px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="3"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Mã ĐBHC: {{ model.tax_payer_organization_code }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 1px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 105px; border: 0px"></td>
          <td style="height: 1px; width: 31px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 37px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 42px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 16px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 26px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 61px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 11px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 34px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td class="s9865db0d" style="width: 4px; height: 1px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 1px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 13px">
          <td
            class="s7c82f25b line-height-114"
            colspan="27"
            rowspan="2"
            style="height: 19px; width: 556px; max-height: 19px; max-width: 556px; white-space: pre-wrap"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span>Tổng số tiền nộp thuế <i>(ghi bằng chữ)</i>: {{ model.total_amonut_tax_text }}</span>
          </td>
          <td style="height: 13px; width: 3px; border: 0px"></td>
          <td class="s9865db0d" style="width: 4px; height: 13px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 13px"></td>
          <td style="height: 13px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 6px">
          <td style="height: 6px; width: 3px; border: 0px"></td>
          <td class="s9865db0d" style="width: 4px; height: 6px"></td>
          <td
            class="sDetailGroupItemTextBoldLeft1"
            colspan="3"
            rowspan="3"
            style="height: 19px; width: 148px; max-height: 19px; max-width: 148px"
          >
            2. Trả đơn vị hưởng:
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 6px"></td>
          <td style="height: 6px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 6px">
          <td style="height: 6px; width: 8px; border: 0px"></td>
          <td style="height: 6px; width: 105px; border: 0px"></td>
          <td style="height: 6px; width: 31px; border: 0px"></td>
          <td style="height: 6px; width: 49px; border: 0px"></td>
          <td style="height: 6px; width: 37px; border: 0px"></td>
          <td style="height: 6px; width: 1px; border: 0px"></td>
          <td style="height: 6px; width: 7px; border: 0px"></td>
          <td style="height: 6px; width: 42px; border: 0px"></td>
          <td style="height: 6px; width: 3px; border: 0px"></td>
          <td style="height: 6px; width: 19px; border: 0px"></td>
          <td style="height: 6px; width: 8px; border: 0px"></td>
          <td style="height: 6px; width: 7px; border: 0px"></td>
          <td style="height: 6px; width: 16px; border: 0px"></td>
          <td style="height: 6px; width: 15px; border: 0px"></td>
          <td style="height: 6px; width: 26px; border: 0px"></td>
          <td style="height: 6px; width: 4px; border: 0px"></td>
          <td style="height: 6px; width: 15px; border: 0px"></td>
          <td style="height: 6px; width: 8px; border: 0px"></td>
          <td style="height: 6px; width: 7px; border: 0px"></td>
          <td style="height: 6px; width: 15px; border: 0px"></td>
          <td style="height: 6px; width: 61px; border: 0px"></td>
          <td style="height: 6px; width: 7px; border: 0px"></td>
          <td style="height: 6px; width: 1px; border: 0px"></td>
          <td style="height: 6px; width: 11px; border: 0px"></td>
          <td style="height: 6px; width: 15px; border: 0px"></td>
          <td style="height: 6px; width: 4px; border: 0px"></td>
          <td style="height: 6px; width: 34px; border: 0px"></td>
          <td style="height: 6px; width: 3px; border: 0px"></td>
          <td class="s9865db0d" style="width: 4px; height: 6px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 6px"></td>
          <td style="height: 6px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 7px">
          <td
            class="sHeaderValueTextBold"
            colspan="28"
            rowspan="3"
            style="height: 23px; width: 559px; max-height: 23px; max-width: 559px"
          >
            THANH TOÁN CHO ĐƠN VỊ HƯỞNG
          </td>
          <td class="s9865db0d" style="width: 4px; height: 7px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 7px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td class="s9865db0d" style="width: 4px; height: 15px"></td>
          <td class="sDetailText4" colspan="3" style="height: 15px; width: 148px; max-height: 15px; max-width: 148px">
            Nợ TK: {{ model.debit_account_1 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 15px"></td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td class="s9865db0d" style="width: 4px; height: 1px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Có TK: {{ model.credit_account_1 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 1px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 14px">
          <td
            class="sDetailText"
            colspan="28"
            rowspan="2"
            style="height: 18px; width: 559px; max-height: 18px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Đơn vị nhận tiền: {{ model.organization_name }}
          </td>
          <td class="s9865db0d" style="width: 4px; height: 14px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 14px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td class="s9865db0d" style="width: 4px; height: 4px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Nợ TK: {{ model.debit_account_2 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 4px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 11px">
          <td
            class="s57af6888"
            colspan="28"
            rowspan="2"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Địa chỉ: {{ model.organization_address }}
          </td>
          <td class="s9865db0d" style="width: 4px; height: 11px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 11px"></td>
          <td style="height: 11px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 8px">
          <td class="s9865db0d" style="width: 4px; height: 8px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Có TK: {{ model.debit_account_2 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 8px"></td>
          <td style="height: 8px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 7px">
          <td
            class="s57af6888"
            colspan="27"
            rowspan="2"
            style="white-space: pre-wrap; height: 19px; max-width: 556px; width: 556px; max-height: 19px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span
              >Tài khoản: {{ model.accounting_object_bank_account }} Tại KBNN (NH):
              {{ model.accounting_object_bank_name }}</span
            >
          </td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td class="s9865db0d" style="width: 4px; height: 7px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 7px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 12px">
          <td style="height: 12px; width: 3px; border: 0px"></td>
          <td class="s9865db0d" style="width: 4px; height: 12px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Nợ TK: {{ model.credit_account_2 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 12px"></td>
          <td style="height: 12px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 3px">
          <td
            class="sDetailText no-warp"
            colspan="28"
            rowspan="3"
            style="height: 19px; width: 559px; max-height: 19px; max-width: 559px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Hoặc người nhận tiền:
            ..........................................................................................................................
          </td>
          <td class="s9865db0d" style="width: 4px; height: 3px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 3px"></td>
          <td style="height: 3px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td class="s9865db0d" style="width: 4px; height: 15px"></td>
          <td class="sDetailText4" colspan="3" style="height: 15px; width: 148px; max-height: 15px; max-width: 148px">
            Có TK: {{ model.credit_account_3 }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 15px"></td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td class="s9865db0d" style="width: 4px; height: 1px"></td>
          <td
            class="sDetailText4"
            colspan="3"
            rowspan="2"
            style="height: 15px; width: 148px; max-height: 15px; max-width: 148px"
          >
            Mã ĐBHC: {{ model.DBHC_code }}
          </td>
          <td class="s0e3ffc9a" style="width: 7px; height: 1px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 14px" :style="{fontSize: model.font_size + fontSizeDV}">
          <td
            class="s57af6888 no-warp"
            colspan="4"
            rowspan="3"
            style="height: 19px; width: 193px; max-height: 19px; max-width: 193px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Số CMND: ...................
          </td>
          <td
            class="s57af6888 no-warp"
            colspan="10"
            rowspan="3"
            style="height: 19px; width: 155px; max-height: 19px; max-width: 155px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Cấp ngày: ..................
          </td>
          <td
            class="s57af6888 no-warp"
            colspan="14"
            rowspan="3"
            style="height: 19px; width: 211px; max-height: 19px; max-width: 211px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            Nơi cấp: .............................
          </td>
          <td class="s9865db0d" style="width: 4px; height: 14px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 14px"></td>
          <td style="height: 14px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px">
          <td class="s9865db0d" style="width: 4px; height: 4px"></td>
          <td class="sDetailText5" colspan="3" style="width: 148px; height: 4px"></td>
          <td class="s0e3ffc9a" style="width: 7px; height: 4px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="width: 4px; border: 0px"></td>
          <td class="s59a6c521" style="width: 49px"></td>
          <td class="s59a6c521" style="width: 68px"></td>
          <td class="s59a6c521" style="width: 31px"></td>
          <td style="width: 7px; border: 0px"></td>
          <td style="width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td
            class="s7c82f25b line-height-114"
            colspan="27"
            style="height: 19px; width: 556px; max-height: 19px; max-width: 556px"
            :style="{fontSize: model.font_size + fontSizeDV}"
          >
            <span
              >Tổng số tiền thanh toán cho đơn vị hưởng <i>(ghi bằng chữ)</i>:
              {{ model.total_payment_amount_text }}</span
            >
          </td>
          <td style="height: 19px; width: 3px; border: 0px"></td>
          <td style="height: 19px; width: 4px; border: 0px"></td>
          <td style="height: 19px; width: 49px; border: 0px"></td>
          <td style="height: 19px; width: 68px; border: 0px"></td>
          <td style="height: 19px; width: 31px; border: 0px"></td>
          <td style="height: 19px; width: 7px; border: 0px"></td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 30px" class="footer-report-org">
          <td style="height: 30px; width: 8px; border: 0px"></td>
          <td style="height: 30px; width: 105px; border: 0px"></td>
          <td style="height: 30px; width: 31px; border: 0px"></td>
          <td style="height: 30px; width: 49px; border: 0px"></td>
          <td style="height: 30px; width: 37px; border: 0px"></td>
          <td style="height: 30px; width: 1px; border: 0px"></td>
          <td style="height: 30px; width: 7px; border: 0px"></td>
          <td style="height: 30px; width: 42px; border: 0px"></td>
          <td style="height: 30px; width: 3px; border: 0px"></td>
          <td style="height: 30px; width: 19px; border: 0px"></td>
          <td style="height: 30px; width: 8px; border: 0px"></td>
          <td style="height: 30px; width: 7px; border: 0px"></td>
          <td style="height: 30px; width: 16px; border: 0px"></td>
          <td style="height: 30px; width: 15px; border: 0px"></td>
          <td style="height: 30px; width: 26px; border: 0px"></td>
          <td style="height: 30px; width: 4px; border: 0px"></td>
          <td style="height: 30px; width: 15px; border: 0px"></td>
          <td style="height: 30px; width: 8px; border: 0px"></td>
          <td style="height: 30px; width: 7px; border: 0px"></td>
          <td style="height: 30px; width: 15px; border: 0px"></td>
          <td style="height: 30px; width: 61px; border: 0px"></td>
          <td style="height: 30px; width: 7px; border: 0px"></td>
          <td style="height: 30px; width: 1px; border: 0px"></td>
          <td style="height: 30px; width: 11px; border: 0px"></td>
          <td style="height: 30px; width: 15px; border: 0px"></td>
          <td style="height: 30px; width: 4px; border: 0px"></td>
          <td style="height: 30px; width: 34px; border: 0px"></td>
          <td style="height: 30px; width: 3px; border: 0px"></td>
          <td style="height: 30px; width: 4px; border: 0px"></td>
          <td style="height: 30px; width: 49px; border: 0px"></td>
          <td style="height: 30px; width: 68px; border: 0px"></td>
          <td style="height: 30px; width: 31px; border: 0px"></td>
          <td style="height: 30px; width: 7px; border: 0px"></td>
          <td style="height: 30px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td style="height: 19px; width: 8px; border: 0px"></td>
          <td class="sBC_Sign_Date" colspan="6" style="height: 19px; width: 230px; max-height: 19px; max-width: 230px">
            Ngày ... tháng ... năm ...
          </td>
          <td style="height: 19px; width: 42px; border: 0px"></td>
          <td class="sBC_Sign_Date" colspan="24" style="height: 19px; width: 431px; max-height: 19px; max-width: 431px">
            {{ model.ref_date }}
          </td>
          <td style="height: 19px; width: 7px; border: 0px"></td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 18px">
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td class="sBC_Sign_Title" colspan="6" style="height: 18px; width: 230px; max-height: 18px; max-width: 230px">
            Người nhận tiền
          </td>
          <td style="height: 18px; width: 42px; border: 0px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 19px; border: 0px"></td>
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td
            class="sBC_Sign_Title"
            colspan="10"
            style="height: 18px; width: 174px; max-height: 18px; max-width: 174px"
          >
            {{ model.CompanyChiefAccountantTitle }}
          </td>
          <td
            class="sBC_Sign_Title"
            colspan="10"
            style="height: 18px; width: 196px; max-height: 18px; max-width: 196px"
          >
            {{ model.CompanyDirectorTitle }}
          </td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 18px">
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td
            class="sSignerSubTitle"
            colspan="6"
            rowspan="2"
            style="height: 19px; width: 230px; max-height: 19px; max-width: 230px"
          >
            (Ký, ghi rõ họ tên)
          </td>
          <td style="height: 18px; width: 42px; border: 0px"></td>
          <td style="height: 18px; width: 3px; border: 0px"></td>
          <td style="height: 18px; width: 19px; border: 0px"></td>
          <td style="height: 18px; width: 8px; border: 0px"></td>
          <td
            class="sSignerSubTitle"
            colspan="10"
            rowspan="2"
            style="height: 19px; width: 174px; max-height: 19px; max-width: 174px"
          >
            (Ký, ghi họ tên)
          </td>
          <td
            class="sSignerSubTitle1"
            colspan="10"
            style="height: 18px; width: 196px; max-height: 18px; max-width: 196px"
          >
            (Ký, ghi họ tên, đóng dấu)
          </td>
          <td style="height: 18px; width: 31px; border: 0px"></td>
          <td style="height: 18px; width: 7px; border: 0px"></td>
          <td style="height: 18px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 42px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 11px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 34px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 68px; border: 0px"></td>
          <td style="height: 1px; width: 31px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 64px">
          <td style="height: 64px; width: 8px; border: 0px"></td>
          <td style="height: 64px; width: 105px; border: 0px"></td>
          <td style="height: 64px; width: 31px; border: 0px"></td>
          <td style="height: 64px; width: 49px; border: 0px"></td>
          <td style="height: 64px; width: 37px; border: 0px"></td>
          <td style="height: 64px; width: 1px; border: 0px"></td>
          <td style="height: 64px; width: 7px; border: 0px"></td>
          <td style="height: 64px; width: 42px; border: 0px"></td>
          <td style="height: 64px; width: 3px; border: 0px"></td>
          <td style="height: 64px; width: 19px; border: 0px"></td>
          <td style="height: 64px; width: 8px; border: 0px"></td>
          <td style="height: 64px; width: 7px; border: 0px"></td>
          <td style="height: 64px; width: 16px; border: 0px"></td>
          <td style="height: 64px; width: 15px; border: 0px"></td>
          <td style="height: 64px; width: 26px; border: 0px"></td>
          <td style="height: 64px; width: 4px; border: 0px"></td>
          <td style="height: 64px; width: 15px; border: 0px"></td>
          <td style="height: 64px; width: 8px; border: 0px"></td>
          <td style="height: 64px; width: 7px; border: 0px"></td>
          <td style="height: 64px; width: 15px; border: 0px"></td>
          <td style="height: 64px; width: 61px; border: 0px"></td>
          <td style="height: 64px; width: 7px; border: 0px"></td>
          <td style="height: 64px; width: 1px; border: 0px"></td>
          <td style="height: 64px; width: 11px; border: 0px"></td>
          <td style="height: 64px; width: 15px; border: 0px"></td>
          <td style="height: 64px; width: 4px; border: 0px"></td>
          <td style="height: 64px; width: 34px; border: 0px"></td>
          <td style="height: 64px; width: 3px; border: 0px"></td>
          <td style="height: 64px; width: 4px; border: 0px"></td>
          <td style="height: 64px; width: 49px; border: 0px"></td>
          <td style="height: 64px; width: 68px; border: 0px"></td>
          <td style="height: 64px; width: 31px; border: 0px"></td>
          <td style="height: 64px; width: 7px; border: 0px"></td>
          <td style="height: 64px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 23px">
          <td style="height: 23px; width: 8px; border: 0px"></td>
          <td style="height: 23px; width: 105px; border: 0px"></td>
          <td style="height: 23px; width: 31px; border: 0px"></td>
          <td style="height: 23px; width: 49px; border: 0px"></td>
          <td style="height: 23px; width: 37px; border: 0px"></td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td style="height: 23px; width: 42px; border: 0px"></td>
          <td style="height: 23px; width: 3px; border: 0px"></td>
          <td style="height: 23px; width: 19px; border: 0px"></td>
          <td style="height: 23px; width: 8px; border: 0px"></td>
          <td
            class="sCT_Sign_People"
            editable="53;Text"
            colspan="10"
            style="height: 23px; width: 174px; max-height: 23px; max-width: 174px"
          >
            {{ model.CompanyChiefAccountant }}
          </td>
          <td
            class="sCT_Sign_People"
            editable="54;Text"
            colspan="10"
            style="height: 23px; width: 196px; max-height: 23px; max-width: 196px"
          >
            {{ model.CompanyDirector }}
          </td>
          <td style="height: 23px; width: 31px; border: 0px"></td>
          <td style="height: 23px; width: 7px; border: 0px"></td>
          <td style="height: 23px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 4px" class="footer-report-KB">
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 105px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 37px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 42px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 19px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 16px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 26px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 8px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 61px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
          <td style="height: 4px; width: 11px; border: 0px"></td>
          <td style="height: 4px; width: 15px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 34px; border: 0px"></td>
          <td style="height: 4px; width: 3px; border: 0px"></td>
          <td style="height: 4px; width: 4px; border: 0px"></td>
          <td style="height: 4px; width: 49px; border: 0px"></td>
          <td style="height: 4px; width: 68px; border: 0px"></td>
          <td style="height: 4px; width: 31px; border: 0px"></td>
          <td style="height: 4px; width: 7px; border: 0px"></td>
          <td style="height: 4px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="sBC_Sign_Org" colspan="33" style="height: 19px; width: 718px; max-height: 19px; max-width: 718px">
            KHO BẠC NHÀ NƯỚC
          </td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 15px">
          <td class="sSignerDate" colspan="33" style="height: 15px; width: 718px; max-height: 15px; max-width: 718px">
            Ngày ...... tháng ...... năm ......
          </td>
          <td style="height: 15px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 7px">
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 105px; border: 0px"></td>
          <td style="height: 7px; width: 31px; border: 0px"></td>
          <td style="height: 7px; width: 49px; border: 0px"></td>
          <td style="height: 7px; width: 37px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 42px; border: 0px"></td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td style="height: 7px; width: 19px; border: 0px"></td>
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 16px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 26px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 8px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 61px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
          <td style="height: 7px; width: 11px; border: 0px"></td>
          <td style="height: 7px; width: 15px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 34px; border: 0px"></td>
          <td style="height: 7px; width: 3px; border: 0px"></td>
          <td style="height: 7px; width: 4px; border: 0px"></td>
          <td style="height: 7px; width: 49px; border: 0px"></td>
          <td style="height: 7px; width: 68px; border: 0px"></td>
          <td style="height: 7px; width: 31px; border: 0px"></td>
          <td style="height: 7px; width: 7px; border: 0px"></td>
          <td style="height: 7px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 19px">
          <td class="sBC_Sign_Title" colspan="6" style="height: 19px; width: 231px; max-height: 19px; max-width: 231px">
            Thủ quỹ
          </td>
          <td class="sBC_Sign_Title" colspan="7" style="height: 19px; width: 102px; max-height: 19px; max-width: 102px">
            Kế toán
          </td>
          <td
            class="sBC_Sign_Title"
            colspan="12"
            style="height: 19px; width: 185px; max-height: 19px; max-width: 185px"
          >
            Kế toán trưởng
          </td>
          <td
            class="sBC_Sign_Title1"
            colspan="8"
            style="height: 19px; width: 200px; max-height: 19px; max-width: 200px"
          >
            Giám đốc
          </td>
          <td style="height: 19px; width: 1px; border: 0px"></td>
        </tr>
        <tr style="height: 1px">
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 105px; border: 0px"></td>
          <td style="height: 1px; width: 31px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 37px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 42px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 19px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 16px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 26px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 8px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 61px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
          <td style="height: 1px; width: 11px; border: 0px"></td>
          <td style="height: 1px; width: 15px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 34px; border: 0px"></td>
          <td style="height: 1px; width: 3px; border: 0px"></td>
          <td style="height: 1px; width: 4px; border: 0px"></td>
          <td style="height: 1px; width: 49px; border: 0px"></td>
          <td style="height: 1px; width: 68px; border: 0px"></td>
          <td style="height: 1px; width: 31px; border: 0px"></td>
          <td style="height: 1px; width: 7px; border: 0px"></td>
          <td style="height: 1px; width: 1px; border: 0px"></td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import basePopup from '@/views/base/basePopup';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import msGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import {defineComponent, onMounted, computed, reactive, ref, getCurrentInstance, watch} from 'vue';
import {mapGetters} from 'vuex';
import {ModuleContext} from '@/stores/moduleConst';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetSourcePropertyComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourcePropertyComboConfig.js';
export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    msGridViewer,
  },
  extends: basePopup,
  name: 'C202bOffline',
  props: {
    dataReport: {
      default: {},
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
  },

  setup(props) {
    const {proxy} = getCurrentInstance();
    const dbOptions = ref([]);
    onMounted(() => {
      dbOptions.value = {...proxy.$store.state.dbOption.dbOptions};
      proxy.getVoucherReportData();
      proxy.$nextTick(() => {
        let tr = proxy.$el.querySelectorAll('tr');
        let totalHeight = 0;
        let isFooter = false;
        let isBreak = false;
        let footerClasses = ['footer-report', 'footer-report-org'];
        let maxHeight = 1027;
        tr.forEach(element => {
          totalHeight += element.getBoundingClientRect().height;
          // Footer 1
          if (element.classList.contains('footer-report')) {
            let heightFooter = proxy.getHeightFromClassToClass('footer-report', 'footer-report-org', 350) + 50;
            if (totalHeight + heightFooter > maxHeight) isBreak = true;
            isFooter = true;
          }
          // Footer Đơn vi
          if (!isBreak && element.classList.contains('footer-report-org')) {
            let heightFooterKB = proxy.getHeightFromClassToClass('footer-report-org', 'footer-report-KB', 100) + 88;
            totalHeight += heightFooterKB;
          }

          if (!isFooter && totalHeight > maxHeight) {
            //TH tính grid
            isBreak = true;
          }

          if (
            !isBreak &&
            isFooter &&
            totalHeight > maxHeight &&
            footerClasses.some(x => element.classList.contains(x))
          ) {
            // TH chỉ tính footer
            isBreak = true;
          }
          if (isBreak) {
            element.classList.add('html2pdf__page-break');
            if (element.nextElementSibling.classList.contains('table-row')) {
              element.nextElementSibling.classList.add('border-top');
            }
            let trEmpty = document.createElement('tr');
            trEmpty.style.height = '35px';
            element.parentNode.insertBefore(trEmpty, element.nextElementSibling);

            //Reset biến
            totalHeight = 0;
            isBreak = false;
            // isFooter = false;
          }
        });
        proxy.$emit('generatePDF', true);
      });
    });
    const model = ref({
      CompanyName: '...............................', // dbOption
      bank_account: '...............................',
      bank_name: '...............................',
      project_name:
        '................................................................................................................................................................................................', // Tên CTMT,DA
      project_code: '', // Mã CTMT,DA
      contract_template: '..........................................', //Số CKC, HĐK
      contract_perform:
        '.....................................................................................................................', // Số CKC, HĐTH
      ref_no: '.......', // số ct
      posted_year: 0, //Năm NS
      cash_withdraw_type_id: 0, // Thực chi cash_withdraw_type_id = 6 , ạm ứng cash_withdraw_type_id in (2,3)
      PaymentMethod: 1, // 0 - Chuyển khoản , 2 - Tiền mặt tại KB, 3 - Tiền mặt tài NH
      Detail: [
        {
          description: '', // Diễn giải
          budget_source_property_name: '', // ? vào cột nội dung chi tiết khi v_show_addrow = 1
          budget_sub_item_code: '', // Mã NDKT
          budget_chapter_code: '', // Mã chương
          budget_sub_kind_item_code: '', // Mã ngày KT
          budget_source_property_code: '', // Mã nguồn NSNN
          amount: 0, // số tiền
          tax_amount: 0, // số tiền nộp thế
          payment_amount: 0, // thành toán cho đơn vị hưởng
        },
      ],
      total_amonut: 0, // Tổng số tiền
      total_amonut_text: '...............................', // Số tiền chữ
      total_amonut_tax: 0, // Tổng số tiền thuế
      total_amonut_tax_text: '...............................', // Số tiền chữ thuế
      total_payment_amount: 0, // Tổng số tiền thành toán cho đơn vị hưởng
      total_payment_amount_text: '...............................', // Số tiền chữ thành toán cho đơn vị hưởng
      organization_name: '...............................', // Đơn vị nhận tiền
      organization_address: '...............................', //Địa chỉ
      accounting_object_bank_account: '...............................', //Tài khoản
      accounting_object_bank_name: '...............................', //Tại KBNN (NH)
      accounting_object_name2: '', //Hoặc người nhận tiền (accounting_object_name2)
      paramIdentification_number: '', //Số CMND
      issueDate: '', //Cấp ngày
      issueBy: '', //Nơi cấp
      // -- Phần thuế
      debit_account_tax_1: '...............................', //Nợ TK 1 //...............................
      credit_account_tax_1: '...............................', //Có TK 1
      debit_account_tax_2: '...............................', // Nợ TK 2
      credit_account_tax_2: '...............................', // Có TK 2
      debit_account_tax_3: '...............................', // Nợ TK 3
      credit_account_tax_3: '...............................', // Có TK 3
      tax_payer_organization_code: '.........................', //Mã ĐBHC
      // -end thuế

      // -- Thủ trương đơn vị
      debit_account_1: '...............................', //Nợ TK 1 //...............................
      credit_account_1: '...............................', //Có TK 1
      debit_account_2: '...............................', // Nợ TK 2
      credit_account_2: '...............................', // Có TK 2
      debit_account_3: '...............................', // Nợ TK 3
      credit_account_3: '...............................', // Có TK 3
      DBHC_code: '.........................', // Mã ĐBHC
      // -- end Thử trưởng đơn vị

      collection_agency_tax_code: '.........................', //Mã cơ quan thuê
      ref_date: 'Ngày ... tháng ... năm ....', // Ngày chứng từ  - Ngày / Tháng / Năm - Theo config
      CompanyChiefAccountantTitle: '', // Lấy trong dbOption
      CompanyChiefAccountant: '', // Người ký Kế toán trưởng,
      CompanyDirectorTitle: '', // Lấy trong dbOption
      CompanyDirector: '', // Người ký Thủ trưởng đơn vị,
      use_add_info: false,
      use_sec: false,
      add_info: '',
      add_sec_info: '',
      bank_info_code: '', // Mã tk chi
      bank_info_name: '', // Tên tk chi
      accounting_object_name: '', // Thông tin cấp sec
      accounting_object_id: '', // id cấp séc
      has_font_size: false,
      font_size: 10,
      payment_content: 'description',
      journal_memo: '',
      company_tax_code: '...........................', //Mã số thuế
      NDKT_code: '......................', //mã NDKT
      budget_chapter_code: '......................', //Mã chương
      receipt_agency_name: '..................................................', //Cơ quan quản lý thu
      tax_period: '......................................', //
      state_bank_name:
        '.................................................................................................................', //KBNN hạch toán khoản thu
      company_name: '',
      not_repeat_duplicate: false, // Không lập lại những thông tin trùng nhau
    });
    const fontSizeDV = ref('pt');
    const {accountingObjectCombo} = useCacheAccountingObjectComboConfig();
    const {cacheBudgetItemComboConfig, cacheBudgetSubItemComboConfig} = useCacheBudgetItemComboConfig();
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    const {cacheBudgetSourcePropertyComboConfig} = useCacheBudgetSourcePropertyComboConfig();

    const isNullOrEmpty = value => {
      if (value == undefined || value == null || value === '') return true;
      return false;
    };

    /**
     * Gắn giá trị truyền từ form ngoài
     */
    const setValueInData = (key, value) => {
      if (!isNullOrEmpty(value)) {
        proxy.model[key] = value;
      }
    };

    const getBudgetSubItemName = item => {
      let index = proxy.cacheBudgetSubItemComboConfig.data.findIndex(
        x => x.budget_item_code == item.budget_sub_item_code,
      );
      if (index != -1) return proxy.cacheBudgetSubItemComboConfig.data[index].budget_item_name;
      return '';
    };

    const getBudgetItemName = item => {
      let index = proxy.cacheBudgetItemComboConfig.data.findIndex(x => x.budget_item_code == item.budget_item_code);
      if (index != -1) return proxy.cacheBudgetItemComboConfig.data[index].budget_item_name;
      return '';
    };

    /**
     * Lấy mã nguồn NSSS
     */
    const getBudgetSourcePropertyCode = item => {
      if (!item.budget_source_id) return '';
      let indexBS = proxy.cacheBudgetSourceComboConfig.data.findIndex(x => x.budget_source_id == item.budget_source_id);
      if (indexBS == -1) return '';
      let itemBS = proxy.cacheBudgetSourceComboConfig.data[indexBS];
      let indexBSP = proxy.cacheBudgetSourcePropertyComboConfig.data.findIndex(
        x => x.budget_source_property_id == itemBS.budget_source_property_id,
      );
      if (indexBSP == -1) return '';
      return proxy.cacheBudgetSourcePropertyComboConfig.data[indexBSP].budget_source_property_code;
    };

    /**
     * Lấy nội dung hiện thị
     */
    const getContentDisplay = item => {
      switch (proxy.model.payment_content) {
        case 'description':
          return item.description;
        case 'journal_memo':
          return proxy.model.journal_memo;
        case 'budget_sub_item_name':
          return getBudgetSubItemName(item); // Tên tiểu mục
        case 'budget_item_name':
          let itemName = getBudgetItemName(item);
          let subItemName = getBudgetSubItemName(item);
          let center = '-';
          if (isNullOrEmpty(itemName) || isNullOrEmpty(subItemName)) center = '';
          return `${itemName} ${center} ${subItemName}`; //Tên mục và Tên tiểu mục
        default:
          return '';
      }
    };

    /**
     * Lấy giá trị hiện thi khi lựa chọn "Không lặp lại thông tin trùng nhau"
     */
    const getRowDataDisplay = (oldValue, newValue, isNoDuplicate) => {
      if (!isNoDuplicate) return {oldValue: oldValue, newValue: newValue};
      if (oldValue == newValue) return {oldValue: oldValue, newValue: ''};
      oldValue = newValue;
      return {oldValue: oldValue, newValue: newValue};
    };

    /**
     * Lấy giá trị trong dbOption
     */
    const setDbOptionInReport = () => {
      // Gắn dbOption
      let dbOptionKeys = [
        'CompanyName',
        'CompanyChiefAccountantTitle',
        'CompanyDirectorTitle',
        'CompanyDirector',
        'CompanyChiefAccountant',
      ];
      dbOptionKeys.forEach(element => {
        setValueInData(element, dbOptions.value[element]);
      });
      if (dbOptions.value.PrintTitleAccordingCircularTemplate || proxy.model.CompanyChiefAccountantTitle == '') {
        proxy.model.CompanyChiefAccountantTitle = 'Kế toán trưởng';
      }
      if (dbOptions.value.PrintTitleAccordingCircularTemplate || proxy.model.CompanyDirectorTitle == '') {
        proxy.model.CompanyDirectorTitle = 'Thủ trưởng đơn vị';
      }
      if (!dbOptions.value.PrintPersonNameInReport || dbOptions.value.PrintPersonNameInReportBudget) {
        proxy.model.CompanyChiefAccountant = '';
      }
      if (!dbOptions.value.PrintPersonNameInReport || dbOptions.value.PrintPersonNameInReportBudget) {
        proxy.model.CompanyDirector = '';
      }
    };

    /**
     * Lấy giá cả master và detail báo cáo
     */
    const getMasterAndDetailData = () => {
      var dataVoucher = props.dataReport.dataVoucher;
      var dataParam = props.dataReport.dataParam;
      var dataParamKey = [
        'PaymentMethod',
        'contract_template',
        'contract_perform',
        'debit_account_tax_1',
        'credit_account_tax_1',
        'debit_account_tax_2',
        'credit_account_tax_2',
        'debit_account_tax_3',
        'credit_account_tax_3',
        'debit_account_1',
        'credit_account_1',
        'debit_account_2',
        'credit_account_2',
        'debit_account_3',
        'credit_account_3',
        'DBHC_code',
        'tax_payer_organization_code',
        'organization_code',
        'organization_name',
        'organization_address',
        'accounting_object_code',
        'bank_account',
        'use_add_info',
        'use_sec',
        'add_sec_info',
        'add_info',
        'payment_content',
        'collection_agency_tax_code',
        'company_tax_code',
        'NDKT_code',
        'budget_chapter_code',
        'receipt_agency_name',
        'tax_period',
        'state_bank_name',
        'company_name',
        'not_repeat_duplicate',
        'has_font_size',
      ];
      let masterKeys = [
        'bank_info_code',
        'bank_info_name',
        'accounting_object_bank_account',
        'accounting_object_bank_name',
        'project_name',
        'project_code',
        'accounting_object_name',
        'accounting_object_id',
        'journal_memo',
      ];

      dataParamKey.forEach(element => {
        setValueInData(element, dataParam[element]);
      });

      masterKeys.forEach(element => {
        setValueInData(element, dataVoucher[element]);
      });

      if (dataParam.has_font_size) {
        proxy.model.font_size = dataParam.font_size + 3.5;
        proxy.fontSizeDV = 'px';
      } else {
        proxy.fontSizeDV = 'pt';
      }
      if (isNullOrEmpty(dataParam.state_bank_name) && proxy.model.font_size > 10) {
        proxy.model.state_bank_name =
          '.............................................................................................';
      }
      // Lấy thong tin gắn séc
      if (
        proxy.accountingObjectCombo.length > 0 &&
        proxy.model.accounting_object_id &&
        proxy.model.accounting_object_id != '' &&
        proxy.model.use_sec
      ) {
        let item = proxy.accountingObjectCombo.filter(
          x =>
            x.accounting_object_id == proxy.model.accounting_object_id &&
            (x.is_personal == true || x.is_employee == true),
        );
        if (item) {
          proxy.model.paramIdentification_number = item[0].identification_number;
          if (item[0].issue_date) {
            proxy.model.issueDate = `${item[0].issue_date.getDate()}/${
              item[0].issue_date.getMonth() + 1
            }/${item[0].issue_date.getFullYear()}`;
          }
          proxy.model.issueBy = item[0].issue_by;
        }
      }

      //Tổng tiền
      proxy.model.total_amonut = dataVoucher.total_amount;
      proxy.model.total_amonut_text = numberText(dataVoucher.total_amount);

      proxy.model.ref_no = dataVoucher.ref_no;
      setValueInData('posted_year', proxy.postedDate.getFullYear());
      if (dataVoucher.ref_date) {
        let month =
          dataVoucher.ref_date.getMonth() > 8
            ? `${dataVoucher.ref_date.getMonth() + 1}`
            : `0${dataVoucher.ref_date.getMonth() + 1}`;
        let date =
          dataVoucher.ref_date.getDate() > 9
            ? `${dataVoucher.ref_date.getDate()}`
            : `0${dataVoucher.ref_date.getDate()}`;
        proxy.model.ref_date = `Ngày ${date} tháng ${month} năm ${dataVoucher.ref_date.getFullYear()}`;
      }
      // Dữ liệu detail
      if (dataVoucher.DetailReport?.length > 0) {
        let total_amonut_tax = 0;
        let total_payment_amount = 0;
        let dataDetail = [];
        let old_budget_sub_item_code = '';
        let old_budget_chapter_code = '';
        let old_budget_sub_kind_item_code = '';
        let old_budget_source_property_code = '';
        let is_not_repeat_duplicate = dataParam.not_repeat_duplicate;

        var details = dataVoucher.DetailReport.filter(x => x.state != 3 && x.state != 4);
        details.forEach(item => {
          //lấy budget_source_property_code từ budget_source_id
          let new_budget_source_property_code = getBudgetSourcePropertyCode(item);
          let valueOne = getRowDataDisplay(
            old_budget_sub_item_code,
            item.budget_sub_item_code,
            is_not_repeat_duplicate,
          );
          old_budget_sub_item_code = valueOne.oldValue;
          let valueTwo = getRowDataDisplay(old_budget_chapter_code, item.budget_chapter_code, is_not_repeat_duplicate);
          old_budget_chapter_code = valueTwo.oldValue;
          let valueThree = getRowDataDisplay(
            old_budget_sub_kind_item_code,
            item.budget_sub_kind_item_code,
            is_not_repeat_duplicate,
          );
          old_budget_sub_kind_item_code = valueThree.oldValue;
          let valueFour = getRowDataDisplay(
            old_budget_source_property_code,
            new_budget_source_property_code,
            is_not_repeat_duplicate,
          );
          old_budget_source_property_code = valueFour.oldValue;

          dataDetail.push({
            description: getContentDisplay(item),
            budget_sub_item_code: valueOne.newValue, // Mã NDKT
            budget_chapter_code: valueTwo.newValue, // Mã chương
            budget_sub_kind_item_code: valueThree.newValue, // Mã ngày KT
            budget_source_property_code: valueFour.newValue, // Mã nguồn NSNN
            amount: item.amount, // số tiền
            tax_amount: item.tax_amount,
            payment_amount: item.payment_amount,
          });
          total_amonut_tax += item.tax_amount;
          total_payment_amount += item.payment_amount;
        });

        proxy.model.total_amonut_tax = total_amonut_tax;
        if (total_amonut_tax != 0) {
          proxy.model.total_amonut_tax_text = numberText(total_amonut_tax);
        }
        proxy.model.total_payment_amount = total_payment_amount;
        if (total_payment_amount != 0) {
          proxy.model.total_payment_amount_text = numberText(total_payment_amount);
        }

        proxy.model.DetailReport = ref(dataDetail);
        setValueInData('cash_withdraw_type_id', details[0]?.cash_withdraw_type_id);
      }
    };

    /**
     * Lấy dữ liệu chứng từ để hiện thị
     */
    const getVoucherReportData = () => {
      setDbOptionInReport();
      getMasterAndDetailData();
    };

    /**
     * Xử lý đọc số
     */
    const numberText = input => {
      if (input == 0) {
        return '';
      } else {
        let readNumber = input || 0;
        let isNegative = readNumber < 0;
        let readText = read((isNegative ? -readNumber : readNumber).toString());
        let result;
        if (isNegative) {
          result = 'Âm ' + readText;
        } else {
          result = readText.charAt(0).toUpperCase() + readText.slice(1);
        }
        if (result != null) {
          result = result.trim();
        }
        if (result == '') {
          result += 'Không';
        }
        result += ` đồng`;
        if (dbOptions.value.SayMoney_Even) {
          result += ' chẵn';
        }
        return dbOptions.value.SayMoney_Prefix + result + dbOptions.value.SayMoney_Surfix;
      }
    };

    const read = num => {
      // Đọc từng phần
      const output = [];

      let groupLength = num.length % 3;

      num = num.split('');
      for (let i = 0; i < 3 - groupLength && groupLength != 0; i++) {
        num.unshift('0');
      }
      num = num.join('');

      for (let i = 0; i < num.length / 3; i++) {
        let [a, b, c] = num.substr(i * 3, 3);
        a = parseInt(a);
        b = parseInt(b);
        c = parseInt(c);

        // Sửa lại ở đây
        const isFirstGroup = i == 0;
        // Nếu là rỗng thì sang bộ 3 tiếp theo
        if (a == 0 && b == 0 && c == 0) {
          continue;
        }

        output.push(...readThree(a, b, c, !isFirstGroup)); // Dùng spread operator

        // Đọc phần đơn vị của nhóm
        output.push(`${genUnits(num.length / 3 - 1 - i)}`);
      }
      return output.join(' ');
    };

    /**
     * giá trị đơn vị
     */
    const genUnits = index => {
      switch (index) {
        case 0:
          return '';
        default:
          let modIndex = index % 3;
          let res = '';
          switch (modIndex) {
            case 0:
              res = 'tỷ';
              break;
            case 1:
              res = `${dbOptions.value.SayMoney_Nghin}`;
              break;
            case 2:
              res = 'triệu';
              break;
          }
          if (dbOptions.value.SayMoney_ShowThousandSymbol) {
            res += ',';
          }
          return res;
      }
    };

    /**
     * Giá trị phần số
     */
    const genDigits = number => {
      switch (number) {
        case 0:
          return 'không';
        case 1:
          return 'một';
        case 2:
          return 'hai';
        case 3:
          return 'ba';
        case 4:
          return 'bốn';
        case 5:
          return 'năm';
        case 6:
          return 'sáu';
        case 7:
          return dbOptions.value.SayMoney_7;
        case 8:
          return 'tám';
        case 9:
          return 'chín';
      }
    };

    // Định nghĩa function đọc hai số cuối
    function readTwo(b, c, hasHundred) {
      const output = [];

      switch (b) {
        case 0: {
          // Nếu có đọc hàng trăm (đọc rồi) và b = 0, c = 0
          // thì không đọc nữa
          if (hasHundred && c == 0) break;
          if (hasHundred) output.push(dbOptions.value.SayMoney_Linh); // ví dụ a05 đọc là "a lẻ năm"
          output.push(genDigits(c));
          break;
        }

        case 1: {
          // Trường hợp số hàng chục là 10
          output.push('mười');
          if (c == 5) output.push('lăm'); // Mười lăm
          else if (c != 0) output.push(genDigits(c));
          // Trường hợp c = 0 không xét vì đã đọc "mười" rồi
          break;
        }

        default: {
          output.push(genDigits(b), dbOptions.value.SayMoney_Muoi); // b mươi
          if (c == 1) output.push('mốt');
          // Chỗ này đọc "tư" hay "bốn" thì các bạn điều chỉnh nhe
          // Mình sẽ luôn đọc là "tư" nhé
          else if (c == 4) output.push(dbOptions.value.SayMoney_4);
          else if (c == 5) output.push('lăm');
          else if (c != 0) output.push(genDigits(c));
          // Không đọc c = 0 vì đã đọc "b mươi" rồi
          break;
        }
      }

      // Trả về mảng output, xem lại phần trước nhé
      return output;
    }

    // Định nghĩa function đọc 3 số
    function readThree(a, b, c, readZeroHundred) {
      const output = [];

      // Đọc phần trăm (a) trước
      if (a != 0 || readZeroHundred) output.push(genDigits(a), 'trăm'); // Đọc là "a trăm"

      // Nối thêm phần sau (b, c)
      // Ở đây dùng spread syntax để nối output
      output.push(...readTwo(b, c, a != 0 || readZeroHundred));

      return output;
    }

    /**
     * Tính khoảng cách từ class đến class
     */
    const getHeightFromClassToClass = (formClass, toClass, defaultValue) => {
      let total = 0;
      try {
        let form = document.getElementsByClassName(formClass);
        if (!form || form?.length == 0) return total;
        let itemTr = form[0];
        do {
          total += itemTr.getBoundingClientRect().height;
          itemTr = itemTr.nextElementSibling;
        } while (!itemTr.classList.contains(toClass));
      } catch (ex) {
        total = defaultValue;
      }

      return total;
    };

    return {
      proxy,
      model,
      dbOptions,
      getVoucherReportData,
      numberText,
      accountingObjectCombo,
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetSourceComboConfig,
      cacheBudgetSourcePropertyComboConfig,
      getHeightFromClassToClass,
      fontSizeDV,
    };
  },
};
</script>
<style lang="scss" scoped>
.c202b-offline {
  background-color: white;
  .h-31px {
    height: 31px;
  }
  .h-19px {
    height: 19px;
  }
  .sDetailTextCenter {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sc711c7f2 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sFormNo {
    font: bold 12pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailText1 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sd6f96e9b {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sReportTitle {
    font: bold 16pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s47c6a550 {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s9865db0d {
    font: 8pt Arial;
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s0e3ffc9a {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText2 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s858ff519 {
    font: 8pt Arial;
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText3 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sCT_Table_DetailText_MLNS {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s1c15de7e {
    font: 8pt Arial;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s57af6888 {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .line-height-114 {
    line-height: 1.14em !important;
  }
  .s65b279dc {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.2em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s5f74eea3 {
    font: 8pt Arial;
    border: 0px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailHeader {
    font: bold 10.7pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right: 1px solid black;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailHeader1 {
    font: bold 10.7pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sBC_Table_SubHeader {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    direction: rtl;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sBC_Table_SubHeader1 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    direction: rtl;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sBC_Table_SubHeader2 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sefb06f20 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: #80808075;
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s61cae64c {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: #80808075;
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .border-bottom-none {
    border-bottom: none !important;
  }
  .sfcb10c25 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: #80808075;
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s4361e9ae {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: #80808075;
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sc80c2ba0 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: #80808075;
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .scf5ddf69 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: #80808075;
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sce8dc10b {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s654145e8 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s7f4c8130 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-bottom-color: Black;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s2e415322 {
    font: bold 10pt 'Times New Roman';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s096ed1b5 {
    font: bold 9pt 'Arial Narrow';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s59a6c521 {
    font: 8pt Arial;
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sa5d47ccf {
    font: 8pt Arial;
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s2fc2a26e {
    font: 8pt Arial;
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailHeader2 {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailGroupItemTextBoldLeft {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    border-top-color: Black;
    border-top-style: solid;
    border-top-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: top;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sHeaderValueTextBold {
    font: bold 12pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailText4 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .s7c82f25b {
    font: 10pt 'Times New Roman';
    border: 0px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sDetailGroupItemTextBoldLeft1 {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: top;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sDetailText5 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Date {
    font: italic 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Title {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sSignerSubTitle {
    font: italic 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sSignerSubTitle1 {
    font: italic 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sCT_Sign_People {
    font: bold 10pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Org {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sSignerDate {
    font: italic 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    white-space: nowrap;
    overflow: hidden;
  }
  .sBC_Sign_Title1 {
    font: bold 11pt 'Times New Roman';
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .pagemargins {
    padding: 10mm 10mm 5mm 10mm;
    border: 0;
  }
  .title-org {
    white-space: pre-wrap;
    height: 19px;
    max-width: 718px;
    width: 718px;
    max-height: 19px;
  }
  .sd12598ef {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s710795cf {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-left-color: Black;
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: left;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .sb32a2c63 {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s12e6f447 {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .s478c64ad {
    font: 8pt Arial;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    border: 0px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.1em;
    white-space: nowrap;
    overflow: hidden;
  }
  .scc89512f {
    font: 10pt 'Times New Roman';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: center;
    vertical-align: middle;
    line-height: 1.09em;
    word-wrap: break-word;
    overflow: hidden;
  }
  .se65b108d {
    font: 9pt 'Arial Narrow';
    border: 0px;
    border-right-color: Black;
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: #80808075;
    border-top-style: dotted;
    border-top-width: 1px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.1em;
    word-wrap: break-word;
    overflow: hidden;
  }

  .border-top {
    border-top: 1px solid black;
  }
  .border-right {
    border-right: 1px solid black !important;
  }
  .border-left {
    border-left: 1px solid black !important;
  }
  .no-warp {
    white-space: nowrap;
  }
  .ver-top {
    vertical-align: top;
  }
}
</style>
